import React from 'react';
import { NavLink } from 'react-router-dom'


const list = [
    {name: "O mnie", path:"/My-portfolio", exact:true},
    {name: "Projekty", path:"projects"},
    {name: "Umiejętności", path:"skills"},
    {name: "Kontakt", path:"contact"},
]
const Navigation = () => {
    const menu = list.map(item => (
        <li key={item.name}>
            <NavLink to={item.path} exact={item.exact ? item.exact : false}>{item.name}</NavLink>
        </li>
    ))
    return ( 
        <nav>
            <ul>
                {menu}
            </ul>
        </nav>
     );
}
 
export default Navigation;